import React from 'react';
import classnames from 'classnames';

import styles from './alertPersistentStyles';

import XMark from 'SVGs/x_mark';

import isLocalStorageNameSupported from 'buyside/util/isLocalStorageNameSupported';

class AlertPersistent extends React.Component {
  constructor() {
    super();
    this.state = { closed: false };
    this.currentDay = new Date().getDate();
    this.localStorageSupported = isLocalStorageNameSupported();
    this.closeAlert = this.closeAlert.bind(this);
  }

  closeAlert() {
    if (!this.props.noBrowserStorage && this.localStorageSupported) {
      window.localStorage.setItem(`${this.props.name}-dateClosed`, this.currentDay);
    }
    if (this.props.handleClose) this.props.handleClose();
    this.setState({ closed: true });
  }

  render() {
    const { children, name, customStyles } = this.props;

    if (
      this.state.closed ||
      (this.localStorageSupported &&
        String(this.currentDay) === String(window.localStorage.getItem(`${name}-dateClosed`)) &&
        !this.props.noBrowserStorage)
    )
      return null;
    return (
      <div className={classnames(styles.alertPersistent, customStyles)}>
        {children}
        <XMark data-testid="closeIcon" className={styles.closeIcon} onClick={this.closeAlert} />
      </div>
    );
  }
}

export default AlertPersistent;
